// StartScreen.js
import React from 'react';
import bg from '../assets/af00516c-571f-4d4c-8151-458d7339f67c.jpg'
import './StartScreen.css';

function StartScreen({ onStart }) {
  return (
    <div className="start-screen">
      <h1>Welcome to the Quiz App</h1>
      <button onClick={onStart}>Start Quiz</button>
    </div>
  );
}

export default StartScreen;
